export default "__VITE_ASSET__fjyqUIGi__"